import { GlassProvider, useGlassContext } from "@/context/GlassContext";
import Layout from "@/components/Layout";

const IndexContent = () => {
  const { glassTypes } = useGlassContext();

  if (!glassTypes || glassTypes.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-lg text-muted-foreground">Loading application data...</p>
        </div>
      </div>
    );
  }

  return <Layout />;
};

const Index = () => {
  return (
    <GlassProvider>
      <IndexContent />
    </GlassProvider>
  );
};

export default Index;
